import Firebase from "firebase";

export const BOOK_LINK =
  "https://www.amazon.com/Unstuck-Church-Equipping-Experience-Sustained-ebook/dp/B01LWS6KEX/ref=as_li_ss_tl?s=digital-text&ie=UTF8&qid=1490620109&sr=1-1&keywords=the+unstuck+church&linkCode=sl1&tag=tonymorgan-20&linkId=d7b3bbe797d486b61af9b67de13c6b08&__hstc=67460494.c28c8114d8f69662ada945fd4fb0737a.1488378586376.1494520643779.1494530514166.132&__hssc=67460494.1.1494601368054&__hsfp=1612135321&hsCtaTracking=4c91f043-8c9a-4525-830a-52451e9b81eb%7C2083de1d-386d-4f45-b227-b1be0dbf3317";

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAlQqNRvE3_6gGG7n4Lex5QftQoZ076ygk",
  authDomain: "unstuck-app.firebaseapp.com",
  databaseURL: "https://unstuck-app.firebaseio.com",
  projectId: "unstuck-app",
  storageBucket: "unstuck-app.appspot.com",
  messagingSenderId: "516397577712",
};

Firebase.initializeApp(FIREBASE_CONFIG);

export const firebase = Firebase;

export const ASSESS_TYPE_MEMBER = "member";
export const ASSESS_TYPE_LEADER = "leader";
export const ASSESS_TYPE_TEAM = "team";

export const UNSTUCK_BLUE = "#00B2BE";
export const UNSTUCK_GREEN = "#B1C63A";
export const UNSTUCK_BACKGROUND = "#D9D9D9";

export const STAGE_LAUNCH = 0;
export const STAGE_MOMENTUM_GROWTH = 1;
export const STAGE_STRATEGIC_GROWTH = 2;
export const STAGE_SUSTAINABLE_HEALTH = 3;
export const STAGE_MAINTENANCE = 4;
export const STAGE_PRESERVATION = 5;
export const STAGE_LIFE_SUPPORT = 6;

export const STAGES = [
  STAGE_LAUNCH,
  STAGE_MOMENTUM_GROWTH,
  STAGE_STRATEGIC_GROWTH,
  STAGE_SUSTAINABLE_HEALTH,
  STAGE_MAINTENANCE,
  STAGE_PRESERVATION,
  STAGE_LIFE_SUPPORT,
];

export const STAGE_LABELS = {
  [STAGE_LAUNCH]: "Launch",
  [STAGE_MOMENTUM_GROWTH]: "Momentum Growth",
  [STAGE_STRATEGIC_GROWTH]: "Strategic Growth",
  [STAGE_SUSTAINABLE_HEALTH]: "Sustained Health",
  [STAGE_MAINTENANCE]: "Maintenance",
  [STAGE_PRESERVATION]: "Preservation",
  [STAGE_LIFE_SUPPORT]: "Life Support",
};



// WEBPACK FOOTER //
// ./src/constants.js